import { useAppStore } from "@/store/app";
import { useUserStore } from "@/store/user";
import router from "@/router/index";
import text_student from "@/projects/nlx/ui/text_student";
import text_assignment from "../nlx/ui/text_assignment";

export default function () {
  const appStore = useAppStore();
  if (appStore.isProjectExit(text_student.courses)) return;

  // override homepage
  router.addRoute({
    name: "nlx-student-home",
    path: "/home",
    component: (resolve) => require(["./pages/Home.vue"], resolve),
    meta: {
      layout: "content",
    },
  });

  const userStore = useUserStore();
  userStore.overrideHomepage = "/home";

  // create new password form
  router.addRoute({
    name: "nlx-reset-password",
    path: "/reset_password/verify/:key",
    component: (resolve) =>
      require(["./pages/account/CreateNewPassword.vue"], resolve),
    meta: {
      layout: "blank",
    },
  });

  /* Registration form */
  router.addRoute({
    name: "nlx-registration",
    path: "/registration/verify/:key",
    component: (resolve) =>
      require(["./pages/registration/Index.vue"], resolve),
    meta: {
      layout: "blank",
    },
  });

  /* Change email verify page */
  router.addRoute({
    name: "nlx-change-email",
    path: "/email/verify/:key",
    component: (resolve) =>
      require(["./pages/account/VerifyEmail.vue"], resolve),
    meta: {
      layout: "blank",
    },
  });

  /* STUDENT */
  appStore.addProjectMenu({
    icon: "mdi-help-circle-outline",
    title: text_student.document,
    type: "route",
    area: "main",
    url: "/docs",
  });

  appStore.addProjectMenu({
    icon: "mdi-apps",
    title: text_student.apps,
    type: "group",
    area: "main",
    children: [
      { title: text_student.server, type: "url", url: "/" },
      { title: text_student.teacherPortal, type: "url", url: "/cms/" },
      { title: text_student.studentPortal, type: "url", url: "/student/" },
    ],
  });

  appStore.addProjectMenu({
    icon: "mdi-book-outline",
    role: "student",
    title: text_student.courses,
    type: "route",
    url: "/courses",
  });

  appStore.addProjectMenu({
    icon: "mdi-calendar-check-outline",
    role: "student",
    title: text_assignment.assignment,
    type: "route",
    url: "/assignments",
  });

  router.addRoute({
    name: "nlx-student-assignments",
    path: "/assignments",
    component: (resolve) => require(["./pages/assignment/Index.vue"], resolve),
    meta: {
      layout: "content",
    },
  });

  appStore.addProjectMenu({
    icon: "mdi-school-outline",
    role: "student",
    title: text_student.gradebook,
    type: "route",
    url: "/gradebook",
  });

  appStore.addProjectMenu({
    icon: "mdi-cart-variant",
    role: "student",
    title: text_student.orders,
    type: "route",
    url: "/orders",
  });

  appStore.addProjectMenu({
    icon: "mdi-account-circle-outline",
    role: "student",
    title: text_student.account,
    type: "route",
    url: "/account",
  });

  router.addRoute({
    name: "nlx-cms-account",
    path: "/account",
    component: (resolve) => require(["./pages/account/Index.vue"], resolve),
    meta: {
      layout: "content",
    },
  });

  router.addRoute({
    name: "nlx-cms-account-alimni",
    path: "/alumni",
    component: (resolve) => require(["./pages/alumni/Index.vue"], resolve),
    meta: {
      layout: "content",
    },
  });

  router.addRoute({
    name: "nlx-student-courses",
    path: "/courses",
    component: (resolve) => require(["./pages/course/Index.vue"], resolve),
    meta: {
      layout: "content",
    },
  });

  router.addRoute({
    name: "nlx-student-course",
    path: "/courses/:id",
    component: (resolve) => require(["./pages/course/Play.vue"], resolve),
    meta: {
      layout: "blank",
    },
  });

  router.addRoute({
    name: "nlx-student-checkout",
    path: "/checkout/:key",
    component: (resolve) =>
      require(["./pages/ecommerce/Checkout.vue"], resolve),
    meta: {
      layout: "blank",
    },
  });
  router.addRoute({
    name: "nlx-student-orders",
    path: "/orders",
    component: (resolve) => require(["./pages/ecommerce/Orders.vue"], resolve),
    meta: {
      layout: "content",
    },
  });
  router.addRoute({
    name: "nlx-student-invoice",
    path: "/invoice/:id",
    component: (resolve) => require(["./pages/ecommerce/Invoice.vue"], resolve),
    meta: {
      layout: "content",
    },
  });

  router.addRoute({
    name: "nlx-student-gradebook",
    path: "/gradebook",
    component: (resolve) => require(["./pages/gradebook/Index.vue"], resolve),
    meta: {
      layout: "content",
    },
  });

  router.addRoute({
    name: "nlx-student-gradebook-course",
    path: "/gradebook/:id",
    component: (resolve) =>
      require(["./pages/gradebook/CourseResult.vue"], resolve),
    meta: {
      layout: "content",
    },
  });

  router.addRoute({
    name: "nlx-student-transcripts",
    path: "/transcripts/:id",
    component: (resolve) =>
      require(["./pages/transcript/Transcript.vue"], resolve),
    meta: {
      layout: "blank",
    },
  });

  router.addRoute({
    name: "nlx-sis-student",
    path: "/sis/student",
    component: (resolve) => require(["./pages/sis/Student.vue"], resolve),
    meta: {
      layout: "content",
    },
  });

  router.addRoute({
    name: "nlx-stu-docs",
    path: "/docs",
    component: (resolve) =>
      require(["@/projects/docs/features/admin/views/IndexPage.vue"], resolve),
    meta: {
      layout: "doc",
    },
  });

  router.addRoute({
    name: "nlx-stu-docs-id",
    path: "/docs/:id",
    component: (resolve) =>
      require(["@/projects/docs/features/admin/views/IndexPage.vue"], resolve),
    meta: {
      layout: "doc",
    },
  });

  router.addRoute({
    name: "nlx-student-cert",
    path: "/certificates/verify/:certNo",
    component: (resolve) =>
      require(["./pages/certificate/Verify.vue"], resolve),
    meta: {
      layout: "blank",
    },
  });

  router.addRoute({
    name: "nlx-test-pdf",
    path: "/test/pdf",
    component: (resolve) => require(["./pages/test/Pdf.vue"], resolve),
    meta: {
      layout: "content",
    },
  });

  router.addRoute({
    name: "nlx-whiteboard",
    path: "/whiteboard/:id",
    component: (resolve) => require(["./pages/whiteboard/WhiteBoard.vue"], resolve),
    meta: {
      layout: "blank",
    },
  });

  router.addRoute({
    name: "nlx-test-wordcloud",
    path: "/test/wordcloud",
    component: (resolve) => require(["./pages/test/WordCloud.vue"], resolve),
    meta: {
      layout: "content",
    },
  });

  router.addRoute({
    name: "nlx-promotion-apply",
    path: "/promotions/:name",
    component: (resolve) => require(["./pages/promotion/Apply.vue"], resolve),
    meta: {
      layout: "content",
    },
  });

  router.addRoute({
    name: "nlx-student-scorm",
    path: "/scorm/:id",
    component: (resolve) => require(["./pages/scorm/ScormRun.vue"], resolve),
    meta: {
      layout: "blank",
    },
  });

  router.addRoute({
    name: "nlx-alumnit-signup",
    path: "/alumni/signup",
    component: (resolve) => require(["./pages/alumni/Signup.vue"], resolve),
    meta: {
      layout: "blank",
    },
  });
}
